var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticStyle:{"background-color":"rgba(255, 255, 255, 0.5)"},attrs:{"color":"color1","icon":""}},[_c('v-icon',[_vm._v("mdi-share-variant-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }